import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupApi } from '@/features/api/hooks/grapevine-group/useGrapevineGroupApi';
import { useAuth } from '@/features/authorization/provider/useAuth';
import { isEmptyOrNull } from '@/shared/utils/string';

export const useGetGroup = (groupId = '') => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevineGroupApi();

  return useQuery({
    queryKey: [API_CACHE_KEYS.GROUP, groupId],
    queryFn: () => api.getGroupById({ groupId }),
    enabled: isAuthenticated && !isEmptyOrNull(groupId)
  });
};
